import { graphql } from '../../gql';

export const DELETE_INSURANCE_RATE = graphql(`
  mutation deleteRate($rateId: ID!, $token: String!) {
    deleteRate(rateId: $rateId, token: $token) {
      id
    }
  }
`);
